import { Component, Element, Fragment, h, Prop, State, Event, EventEmitter, Host } from '@stencil/core';
import { modalController } from '@ionic/core';

@Component({
  tag: 'concourse-message-modal',
})
export class ConcourseMessageModal {
  static async present(modalTitle: string, placeholder: string, buttonName: string = 'Submit'): Promise<string | null> {
    const modal = await modalController.create({
      component: 'concourse-message-modal',
      cssClass: 'modal-height-auto concourse-modal',
      componentProps: {
        modalTitle,
        placeholder,
        buttonName,
      },
      showBackdrop: true,
      backdropDismiss: false,
    });

    return new Promise(resolve => {
      modal.addEventListener('buttonClick', (e: CustomEvent<string>) => {
        modal.dismiss();
        resolve(e.detail);
      });

      modal.addEventListener('cancel', () => {
        modal.dismiss();
        resolve(null);
      });

      modal.present();
    });
  }

  @Element() el: HTMLElement;

  @Prop() modalTitle: string;
  @Prop() placeholder: string;
  @Prop() buttonName: string = 'Submit';
  @Prop() cancelButtonName: string = 'Cancel';

  @State() message: string = '';
  @Event() buttonClick: EventEmitter<string>;
  @Event() cancel: EventEmitter<void>;

  handleButtonClick() {
    this.buttonClick.emit(this.message.trim());
  }

  handleCancel() {
    this.cancel.emit();
  }

  render() {
    return (
      <Host class="concourse-modal">
        <modal-header modalTitle={this.modalTitle} onDismiss={() => this.handleCancel()}></modal-header>
        <div class="ion-padding">
          <ion-textarea
            label="Message"
            label-placement="stacked"
            value={this.message}
            onIonInput={e => (this.message = e.detail.value)}
            placeholder={this.placeholder}
            rows={4}
            maxlength={500}
            counter={true}
          ></ion-textarea>
        </div>
        <ion-footer>
          <ion-toolbar>
            <ion-button slot="end" color="primary" shape="round" fill="solid" onClick={() => this.handleButtonClick()}>
              {this.buttonName}
            </ion-button>
          </ion-toolbar>
        </ion-footer>
      </Host>
    );
  }
}
